module.exports = __webpack_public_path__ + "img/adx-ic-warning.5761f17e.svg";